import { render } from "./OAuth2DomainMappingTab.vue?vue&type=template&id=ff18a316&scoped=true"
import script from "./OAuth2DomainMappingTab.vue?vue&type=script&lang=js"
export * from "./OAuth2DomainMappingTab.vue?vue&type=script&lang=js"

import "./OAuth2DomainMappingTab.vue?vue&type=style&index=0&id=ff18a316&scoped=true&lang=less"

import exportComponent from "/builds/cloudstack/keycloak-auth/.cloudstack-src/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff18a316"]])

export default __exports__